import * as TYPES from './actions/types';

const initialState = {
  loadingIndicators: [],
};

const addKeyToLoadingIndicators = (loadingIndicators, key) => {
  if (loadingIndicators.indexOf(key) === -1) {
    loadingIndicators.push(key);
  }
  return loadingIndicators;
};

const removeKeyFromLoadingIndicators = (loadingIndicators, key) => {
  const indexOfKey = loadingIndicators.indexOf(key);
  if (indexOfKey > -1) {
    loadingIndicators.splice(indexOfKey, 1);
  }
  return loadingIndicators;
};

const loadingIndicatorReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.SHOW_LOADING_INDICATOR:
      newState = { ...state,
        loadingIndicators: addKeyToLoadingIndicators(state.loadingIndicators.slice(0), action.key) };
      break;
    case TYPES.HIDE_LOADING_INDICATOR:
      newState = { ...state,
        loadingIndicators: removeKeyFromLoadingIndicators(state.loadingIndicators.slice(0), action.key) };
      break;
    default:
      newState = { ...state };
      break;
  }

  return newState;
};

export default loadingIndicatorReducer;
